const Shortened = () =>
  import(
    /* webpackChunkName: "system-url-shortened" */ '@/pages/system/url/shortened/index.vue'
  )
const CreateShortened = () =>
  import(
    /* webpackChunkName: "system-url-shortened" */ '@/pages/system/url/shortened/create.vue'
  )
const EditShortened = () =>
  import(
    /* webpackChunkName: "system-url-shortened" */ '@/pages/system/url/shortened/edit.vue'
  )

export default {
  path: 'shortened',
  meta: {
    label: 'UrlShortened',
    auth: 'shortened'
  },
  component: {
    name: 'Shortened',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemUrlShortened',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Shortened
    },
    {
      name: 'SystemCreateUrlShortened',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateShortened
    },
    {
      name: 'SystemEditUrlShortened',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditShortened,
      props: true
    }
  ]
}
